// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-red: #c53131;
  --primary-black: #2b2c2a;
  --bg-light: #f8f9fa;
  --text-gray: #6c757d;
  --border-light: #e9ecef;
  --success-green: #28a745;
  --warning-orange: #fd7e14;
  --info-blue: #71a2c0;
  --bg-blue:#076599;
  --white: #ffffff;
  --shadow-light: rgba(43, 44, 42, 0.08);
  --shadow-medium: rgba(43, 44, 42, 0.15);
}
.App {
  text-align: center;
}
body {
  font-family: 'Be Vietnam Pro', sans-serif !important;
  margin: 0 !important;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}
.MuiOutlinedInput-root {
  background-color: transparent !important;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.MuiBreadcrumbs-li::before {
  content: none !important;
}
.MuiBreadcrumbs-separator::before {
  content: none !important;
}
.css-ikm6hp-MuiTypography-root {
  font-weight: 100 !important;
}
.button2
{
  background-color:var(--bg-blue) !important;
  border: none !important;
  border: 5px !important;
}
input:-webkit-autofill {
  appearance: none;
  background-color: none !important; 
  color: inherit !important;
  -webkit-text-fill-color: inherit !important; 
  box-shadow: 0 !important; 
  -webkit-transition: background-color 5000s ease-in-out 0s !important; 
  transition: background-color 5000s ease-in-out 0s !important; 
}


/* css start */

.css-1m6gnoi-MuiPaper-root-MuiCard-root {
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: 4px;
  box-shadow: var(--Paper-shadow);
  background-image: var(--Paper-overlay);
  overflow: hidden;
  max-width: 480px;
  min-height: 160px;
  max-height: 345px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #e0e4e8;
}

.css-1m6gnoi-MuiPaper-root-MuiCard-root {
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: 4px;
  box-shadow: var(--Paper-shadow);
  background-image: var(--Paper-overlay);
  overflow: hidden;
  max-width: 480px;
  min-height: 160px !important;
  max-height: 345px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05) !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #e0e4e8 !important;
}

.css-yyg9xj {
  padding: 10px 16px !important;
}

.css-pbjjy9 {
  width: 40px !important;
  height: 40px !important;
  color: #fff;
    font-size: 20px;
    background-color: #66a321;
}

.css-gemjvp-MuiButtonBase-root-MuiButton-root{
  min-width: 30% !important;
  background-color: transparent !important;
  border-radius: 8px !important;
  border: 1px solid #eee !important;
  font-size: 18px;
  line-height: 1.2;
}

.css-gemjvp-MuiButtonBase-root-MuiButton-root:hover{
  background-color: #014671 !important;
  color: #fff !important;
}


.css-4bnoyw{
  background-color: #f5f7fa !important;
}

.css-13emikv{
  background-color: #f5f7fa !important;
}

.css-irrfx6{
  padding: 20px 0px 20px !important;
}

.css-4bnoyw{
  height: 89vh !important;
}



.css-j76wmq-MuiButtonBase-root-MuiIconButton-root{
  color: #f35858 !important;
  width: 38px !important;
  height: 38px !important;
}

.css-j76wmq-MuiButtonBase-root-MuiIconButton-root:hover{
  color: #d83636 !important;
  background-color: #fff4f4 !important;
  width: 38px !important;
  height: 38px !important;
}

.css-1hzqitg-MuiCardContent-root{
  min-height: 183px !important;
}


.css-h1o20q{
  padding: 20px !important;
}

.css-3jc6jn-MuiListItem-root{
  background-color: #014671 !important;
}

.css-b7dj7n-MuiList-root{
  padding-top: 20px !important;
}

.css-4uu1we-MuiTypography-root{
  color: #66a321 !important;
  font-size: 1rem !important;
  font-weight: 700 !important;
}

.css-m4ra40 {
  padding: 0px 0px !important;
  width: 40% !important;
  margin: auto !important;
}

.css-1ne5kqu {
  border: 1px solid #e0e0e0 !important;
  padding: 15px !important;
}

.css-1ne5kqu {
  border: none !important;
  padding: 15px !important;
  background-color: #f1f4f7 !important;
  margin-top: 10px !important;
  border-radius: 10px !important;
}

.css-1bhmf50-MuiPaper-root-MuiCard-root:hover{
  box-shadow: none !important;
}

.css-1bhmf50-MuiPaper-root-MuiCard-root{
  box-shadow: none !important;
}


@media (min-width: 600px) {
  .css-11ukpt7-MuiTypography-root {
      margin-left: 25px !important;
      margin-top: 0px !important;
  }
}

@media (max-width: 1400px) {
  .css-m4ra40{
    width: 80% !important;
  }
}

.css-r4gh2z-MuiCardContent-root:last-child {
  padding-bottom: 15px !important;
}
.setupbtn
{
  background-color: var(--white) !important;
  color:var(--primary-black) !important;
  box-shadow: 0px 0px 4px #c3c3c3 !important;
}

.css-14gfh60-MuiChip-root{
  border: 1px solid #67af8c !important;
  background-color: transparent !important;
  color: #67af8c !important;
}
.css-1hkxhtb:last-child {
     padding-bottom: 13px !important; 
}
@media print {
  body {
    -webkit-print-color-adjust: exact;
  }

  .no-print {
    display: none !important;
  }
}

* {
  page-break-before: avoid;
  page-break-after: avoid;
  page-break-inside: avoid;
}

/* ==========================================
   Product Valuation Page Styles
   ========================================== */

.pv-label {
  font-size: 0.82rem !important;
  font-weight: 600 !important;
  color: var(--primary-black);
  margin-bottom: 4px;
}

.pv-small-label {
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  color: #555;
  margin-bottom: 4px;
}

.pv-section-title {
  font-size: 1.05rem !important;
  font-weight: 700 !important;
  color: #66a321  ;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid var(--border-light);
}

.pv-input .MuiOutlinedInput-root {
  font-size: 0.875rem;
}

.pv-input .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: var(--bg-blue);
}

.pv-input .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: var(--bg-blue);
}

.pv-textarea .MuiOutlinedInput-root {
  font-size: 0.875rem;
  height: auto !important;
}

.pv-textarea .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: var(--bg-blue);
}

.pv-textarea .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: var(--bg-blue);
}

.pv-company-header {
  background: linear-gradient(135deg, #076599 0%, #0a4a6e 100%);
  border-radius: 10px 10px 0 0;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.pv-product-card {
  padding: 20px;
  border-radius: 10px;
  border: 1px solid #e0e4e8;
  margin-bottom: 16px;
  background-color: var(--white);
}

/* Section Card Blocks */
.pv-section-card {
  margin-bottom: 20px;
  border-radius: 12px !important;
  border: 1px solid #e0e4e8 !important;
  overflow: hidden;
  background-color: #fff !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
  transition: box-shadow 0.2s ease;
}

.pv-section-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
}

.pv-section-card-header {
  padding: 14px 20px;
  background: linear-gradient(135deg, #f8fafd 0%, #eef3f8 100%);
  border-bottom: 1px solid #e0e4e8;
  display: flex;
  align-items: center;
  gap: 12px;
}

.pv-section-card-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pv-section-card-body {
  padding: 20px 24px;
}



`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;EACtC,uCAAuC;AACzC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oDAAoD;EACpD,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,0CAA0C;EAC1C,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,2CAA2C;EAC3C,wBAAwB;EACxB,oEAA4D;EAA5D,4DAA4D;AAC9D;;;AAGA,cAAc;;AAEd;EACE,sBAAsB;EACtB,0BAA0B;EAE1B,6DAA6D;EAC7D,kBAAkB;EAClB,+BAA+B;EAC/B,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAIhB,aAAa;EAGb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAE1B,6DAA6D;EAC7D,kBAAkB;EAClB,+BAA+B;EAC/B,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;EACnB,qDAAqD;EACrD,gBAAgB;EAIhB,aAAa;EAGb,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;IACT,eAAe;IACf,yBAAyB;AAC7B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,6BAA6B;EAC7B,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;;AAGA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;;;AAIA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;;AAGA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;EACE;MACI,4BAA4B;MAC5B,0BAA0B;EAC9B;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,+BAA+B;AACjC;AACA;;EAEE,yCAAyC;EACzC,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,yBAAyB;AAC3B;AACA;KACK,+BAA+B;AACpC;AACA;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;+CAE+C;;AAE/C;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;EAC7D,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,oCAAoC;EACpC,gBAAgB;EAChB,iCAAiC;EACjC,oDAAoD;EACpD,gCAAgC;AAClC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[":root {\r\n  --primary-red: #c53131;\r\n  --primary-black: #2b2c2a;\r\n  --bg-light: #f8f9fa;\r\n  --text-gray: #6c757d;\r\n  --border-light: #e9ecef;\r\n  --success-green: #28a745;\r\n  --warning-orange: #fd7e14;\r\n  --info-blue: #71a2c0;\r\n  --bg-blue:#076599;\r\n  --white: #ffffff;\r\n  --shadow-light: rgba(43, 44, 42, 0.08);\r\n  --shadow-medium: rgba(43, 44, 42, 0.15);\r\n}\r\n.App {\r\n  text-align: center;\r\n}\r\nbody {\r\n  font-family: 'Be Vietnam Pro', sans-serif !important;\r\n  margin: 0 !important;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n.MuiOutlinedInput-root {\r\n  background-color: transparent !important;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n.MuiBreadcrumbs-li::before {\r\n  content: none !important;\r\n}\r\n.MuiBreadcrumbs-separator::before {\r\n  content: none !important;\r\n}\r\n.css-ikm6hp-MuiTypography-root {\r\n  font-weight: 100 !important;\r\n}\r\n.button2\r\n{\r\n  background-color:var(--bg-blue) !important;\r\n  border: none !important;\r\n  border: 5px !important;\r\n}\r\ninput:-webkit-autofill {\r\n  appearance: none;\r\n  background-color: none !important; \r\n  color: inherit !important;\r\n  -webkit-text-fill-color: inherit !important; \r\n  box-shadow: 0 !important; \r\n  transition: background-color 5000s ease-in-out 0s !important; \r\n}\r\n\r\n\r\n/* css start */\r\n\r\n.css-1m6gnoi-MuiPaper-root-MuiCard-root {\r\n  background-color: #fff;\r\n  color: rgba(0, 0, 0, 0.87);\r\n  -webkit-transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\r\n  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\r\n  border-radius: 4px;\r\n  box-shadow: var(--Paper-shadow);\r\n  background-image: var(--Paper-overlay);\r\n  overflow: hidden;\r\n  max-width: 480px;\r\n  min-height: 160px;\r\n  max-height: 345px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-flex-direction: column;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  border: 1px solid #e0e4e8;\r\n}\r\n\r\n.css-1m6gnoi-MuiPaper-root-MuiCard-root {\r\n  background-color: #fff;\r\n  color: rgba(0, 0, 0, 0.87);\r\n  -webkit-transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\r\n  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\r\n  border-radius: 4px;\r\n  box-shadow: var(--Paper-shadow);\r\n  background-image: var(--Paper-overlay);\r\n  overflow: hidden;\r\n  max-width: 480px;\r\n  min-height: 160px !important;\r\n  max-height: 345px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05) !important;\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-flex-direction: column;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  border: 1px solid #e0e4e8 !important;\r\n}\r\n\r\n.css-yyg9xj {\r\n  padding: 10px 16px !important;\r\n}\r\n\r\n.css-pbjjy9 {\r\n  width: 40px !important;\r\n  height: 40px !important;\r\n  color: #fff;\r\n    font-size: 20px;\r\n    background-color: #66a321;\r\n}\r\n\r\n.css-gemjvp-MuiButtonBase-root-MuiButton-root{\r\n  min-width: 30% !important;\r\n  background-color: transparent !important;\r\n  border-radius: 8px !important;\r\n  border: 1px solid #eee !important;\r\n  font-size: 18px;\r\n  line-height: 1.2;\r\n}\r\n\r\n.css-gemjvp-MuiButtonBase-root-MuiButton-root:hover{\r\n  background-color: #014671 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n\r\n.css-4bnoyw{\r\n  background-color: #f5f7fa !important;\r\n}\r\n\r\n.css-13emikv{\r\n  background-color: #f5f7fa !important;\r\n}\r\n\r\n.css-irrfx6{\r\n  padding: 20px 0px 20px !important;\r\n}\r\n\r\n.css-4bnoyw{\r\n  height: 89vh !important;\r\n}\r\n\r\n\r\n\r\n.css-j76wmq-MuiButtonBase-root-MuiIconButton-root{\r\n  color: #f35858 !important;\r\n  width: 38px !important;\r\n  height: 38px !important;\r\n}\r\n\r\n.css-j76wmq-MuiButtonBase-root-MuiIconButton-root:hover{\r\n  color: #d83636 !important;\r\n  background-color: #fff4f4 !important;\r\n  width: 38px !important;\r\n  height: 38px !important;\r\n}\r\n\r\n.css-1hzqitg-MuiCardContent-root{\r\n  min-height: 183px !important;\r\n}\r\n\r\n\r\n.css-h1o20q{\r\n  padding: 20px !important;\r\n}\r\n\r\n.css-3jc6jn-MuiListItem-root{\r\n  background-color: #014671 !important;\r\n}\r\n\r\n.css-b7dj7n-MuiList-root{\r\n  padding-top: 20px !important;\r\n}\r\n\r\n.css-4uu1we-MuiTypography-root{\r\n  color: #66a321 !important;\r\n  font-size: 1rem !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.css-m4ra40 {\r\n  padding: 0px 0px !important;\r\n  width: 40% !important;\r\n  margin: auto !important;\r\n}\r\n\r\n.css-1ne5kqu {\r\n  border: 1px solid #e0e0e0 !important;\r\n  padding: 15px !important;\r\n}\r\n\r\n.css-1ne5kqu {\r\n  border: none !important;\r\n  padding: 15px !important;\r\n  background-color: #f1f4f7 !important;\r\n  margin-top: 10px !important;\r\n  border-radius: 10px !important;\r\n}\r\n\r\n.css-1bhmf50-MuiPaper-root-MuiCard-root:hover{\r\n  box-shadow: none !important;\r\n}\r\n\r\n.css-1bhmf50-MuiPaper-root-MuiCard-root{\r\n  box-shadow: none !important;\r\n}\r\n\r\n\r\n@media (min-width: 600px) {\r\n  .css-11ukpt7-MuiTypography-root {\r\n      margin-left: 25px !important;\r\n      margin-top: 0px !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 1400px) {\r\n  .css-m4ra40{\r\n    width: 80% !important;\r\n  }\r\n}\r\n\r\n.css-r4gh2z-MuiCardContent-root:last-child {\r\n  padding-bottom: 15px !important;\r\n}\r\n.setupbtn\r\n{\r\n  background-color: var(--white) !important;\r\n  color:var(--primary-black) !important;\r\n  box-shadow: 0px 0px 4px #c3c3c3 !important;\r\n}\r\n\r\n.css-14gfh60-MuiChip-root{\r\n  border: 1px solid #67af8c !important;\r\n  background-color: transparent !important;\r\n  color: #67af8c !important;\r\n}\r\n.css-1hkxhtb:last-child {\r\n     padding-bottom: 13px !important; \r\n}\r\n@media print {\r\n  body {\r\n    -webkit-print-color-adjust: exact;\r\n  }\r\n\r\n  .no-print {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n* {\r\n  page-break-before: avoid;\r\n  page-break-after: avoid;\r\n  page-break-inside: avoid;\r\n}\r\n\r\n/* ==========================================\r\n   Product Valuation Page Styles\r\n   ========================================== */\r\n\r\n.pv-label {\r\n  font-size: 0.82rem !important;\r\n  font-weight: 600 !important;\r\n  color: var(--primary-black);\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.pv-small-label {\r\n  font-size: 0.75rem !important;\r\n  font-weight: 600 !important;\r\n  color: #555;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.pv-section-title {\r\n  font-size: 1.05rem !important;\r\n  font-weight: 700 !important;\r\n  color: #66a321  ;\r\n  margin-bottom: 16px;\r\n  padding-bottom: 8px;\r\n  border-bottom: 2px solid var(--border-light);\r\n}\r\n\r\n.pv-input .MuiOutlinedInput-root {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.pv-input .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\r\n  border-color: var(--bg-blue);\r\n}\r\n\r\n.pv-input .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\r\n  border-color: var(--bg-blue);\r\n}\r\n\r\n.pv-textarea .MuiOutlinedInput-root {\r\n  font-size: 0.875rem;\r\n  height: auto !important;\r\n}\r\n\r\n.pv-textarea .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\r\n  border-color: var(--bg-blue);\r\n}\r\n\r\n.pv-textarea .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\r\n  border-color: var(--bg-blue);\r\n}\r\n\r\n.pv-company-header {\r\n  background: linear-gradient(135deg, #076599 0%, #0a4a6e 100%);\r\n  border-radius: 10px 10px 0 0;\r\n  padding: 16px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.pv-product-card {\r\n  padding: 20px;\r\n  border-radius: 10px;\r\n  border: 1px solid #e0e4e8;\r\n  margin-bottom: 16px;\r\n  background-color: var(--white);\r\n}\r\n\r\n/* Section Card Blocks */\r\n.pv-section-card {\r\n  margin-bottom: 20px;\r\n  border-radius: 12px !important;\r\n  border: 1px solid #e0e4e8 !important;\r\n  overflow: hidden;\r\n  background-color: #fff !important;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;\r\n  transition: box-shadow 0.2s ease;\r\n}\r\n\r\n.pv-section-card:hover {\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;\r\n}\r\n\r\n.pv-section-card-header {\r\n  padding: 14px 20px;\r\n  background: linear-gradient(135deg, #f8fafd 0%, #eef3f8 100%);\r\n  border-bottom: 1px solid #e0e4e8;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.pv-section-card-icon {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.pv-section-card-body {\r\n  padding: 20px 24px;\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
